
import { AxiosResponse } from 'axios'
import { defineComponent } from 'vue'
import { IPackage, ITrigger } from '../../Workspace'
import WorkspaceSchedulationOldSchedulationsDialog from './dialog/WorkspaceSchedulationOldSchedulationsDialog.vue'
import WorkspaceSchedulationTable from './tables/WorkspaceSchedulationTable.vue'
import { mapState } from 'vuex'

export default defineComponent({
    name: 'workspace-schedulation-view',
    components: { WorkspaceSchedulationOldSchedulationsDialog, WorkspaceSchedulationTable },
    emits: ['showMenu'],
    data() {
        return {
            jobs: [] as IPackage[],
            selectedSchedulations: {} as any,
            schedulationsDialogVisible: false,
            selectedJob: null as IPackage | null,
            loading: false
        }
    },
    computed: {
        ...mapState({
            user: 'user'
        }),
        canRunScheduledExecutions(): any {
            return this.user.functionalities.includes('RunSnapshotsFunctionality')
        }
    },
    async created() {
        await this.loadJobs()
    },
    methods: {
        async loadJobs() {
            this.loading = true
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `scheduleree/listAllJobs`).then((response: AxiosResponse<any>) => (this.jobs = response.data.root))
            this.loading = false
        },
        setSelectedSchedulations(schedulations: any) {
            this.selectedSchedulations = schedulations
        },
        async runSingleSchedulation(schedulation: ITrigger) {
            await this.runSchedulations([{ jobName: schedulation.jobName, jobGroup: schedulation.jobGroup, triggerName: schedulation.triggerName, triggerGroup: schedulation.triggerGroup }])
        },
        async runAllSchedulations() {
            const formatedSchedulations = this.getFormatedSchedulations()
            await this.runSchedulations(formatedSchedulations)
        },
        getFormatedSchedulations() {
            let formatedSchedulations = [] as ITrigger[]
            Object.keys(this.selectedSchedulations).forEach((key) => {
                this.selectedSchedulations[key].forEach((schedulation: ITrigger) => {
                    formatedSchedulations.push({ jobName: schedulation.jobName, jobGroup: schedulation.jobGroup, triggerName: schedulation.triggerName, triggerGroup: schedulation.triggerGroup })
                })
            })
            return formatedSchedulations
        },
        async runSchedulations(schedulations: any) {
            this.loading = true
            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `scheduleree/executeMultipleTrigger`, schedulations)
                .then((response: AxiosResponse<any>) => {
                    if (response.data.resp === 'ok') {
                        this.$store.commit('setInfo', {
                            title: this.$t('common.information'),
                            msg: this.$t('managers.scheduler.schedulationExecuted')
                        })
                    }
                })
                .catch(() => {})
            this.loading = false
        },
        viewOldSchedulations(job: IPackage) {
            this.selectedJob = job
            this.schedulationsDialogVisible = true
        },
        closeOldSchedulationsDialog() {
            this.schedulationsDialogVisible = false
            this.selectedJob = null
        }
    }
})
